<ng-container *ngIf="loaded">
  <div class="uplay-container">
    <div class="items-container">
      <ng-container *ngIf="availableToWatchOn && !purchased">
        <div class="uplay-msg" [attr.data-translate]="uplayMessageKey">{{ uplayMessage }}</div>
      </ng-container>
      <ng-container *ngTemplateOutlet="availableToWatchOn ? notreleased : released"></ng-container>
    </div>
  </div>
</ng-container>

<ng-template #notreleased>
  <ng-container *ngTemplateOutlet="purchased ? waitingtowatch : preorder"></ng-container>
</ng-template>

<ng-template #released>
  <ng-container *ngTemplateOutlet="purchased ? playnow : watchnow"></ng-container>
</ng-template>

<ng-template #preorder>
  <a
    class="clickable uplay-btn preorder button-secondary"
    (click)="preOrderSelected()"
    [routerLink]="getRoute()"
    [state]="getData()"
  >
    <span [attr.data-translate]="moviePreorderText">
      {{ moviePreorderText | translate }}
    </span>
    &nbsp;|&nbsp;
    <span [attr.data-translate]="'movie.from'">{{ 'movie.from' | translate }}</span>
    &nbsp;{{ price }}
  </a>
</ng-template>
<ng-template #playnow>
  <ush-uplay-play-button [userFilmItem]="userPlayItem()" [playNowCustomString]="playNowCustomString" />
</ng-template>
<ng-template #watchnow>
  <a
    class="p-element watchnow-button ctrl-play fullVideo-button"
    (click)="watchNowSelected()"
    [routerLink]="getRoute()"
    [state]="getData()"
  >
    <div class="p-element p-button p-component" style="height: 100%">
      @if (hidePriceOnWatchNowButton) {
        <span class="watch-text-container" [attr.data-translate]="movieWatchNowText">{{
          movieWatchNowText | translate
        }}</span>
      } @else {
        <span class="watch-text-container">
          <span [attr.data-translate]="movieWatchNowText">{{ movieWatchNowText | translate }}</span>
          &nbsp;|&nbsp;
          <span [attr.data-translate]="'movie.from'">{{ 'movie.from' | translate }}</span
          >&nbsp;{{ price }}
        </span>
      }
    </div>
  </a>
</ng-template>
<ng-template #waitingtowatch>
  <a class="uplay-btn waiting-to-watch button-secondary">
    <span [attr.data-translate]="movieAvailableToWatchText">{{ movieAvailableToWatchText | translate }}</span
    >&nbsp;<span>{{ availableToWatchOn }}</span>
  </a>
</ng-template>
